import * as moment from "moment";
import { C } from "../../common/component";
import { Txt } from "../../common/text";
import { EditControl } from "../form-row";

export class DateRangeEditControl implements EditControl
{
    private readonly input: JQuery;
    private readonly inputRow: JQuery;
    private onChangeAction;
    private currentValue: string;

    constructor(placeholder?: string)
    {
        this.inputRow = C.div;
        this.input = C.input.attr("placeholder", placeholder).addClass("form-control").appendTo(
            C.div.addClass("input-group date").appendTo(
                this.inputRow
            )
        );

        this.input.daterangepicker(this.settings, (start, end) =>
        {
            this.currentValue = start.format("DD.MM.YYYY") + "|" + end.format("DD.MM.YYYY");
            if (this.onChangeAction)
            {
                this.onChangeAction();
            }
        });
        this.input[0].addEventListener("blur", () =>
        {
            if (!this.input.val() || this.input.val() === "")
            {
                this.currentValue = null;
                if (this.onChangeAction)
                {
                    this.onChangeAction();
                }
            }
        })
        this.input.on("apply.daterangepicker", (ev, picker) =>
        {
            this.input.val(picker.startDate.format("DD.MM.YYYY") + " - " + picker.endDate.format("DD.MM.YYYY"));
        });
    }

    private get settings()
    {
        const settings = {
            ranges: {},
            showCustomRangeLabel: false,
            alwaysShowCalendars: true,
            autoApply: true,
            locale: {
                firstDay: 1,
                cancelLabel: Txt.cancel,
                applyLabel: Txt.edit,
                daysOfWeek: Txt.dayNamesShort,
                monthNames: Txt.monthNames,
                format: "DD.MM.YYYY",
            },
            autoUpdateInput: false
        };

        settings.ranges[Txt.rangeYesterday] = [moment().subtract(1, "days"), moment().subtract(1, "days")];
        settings.ranges[Txt.rangeToday] = [moment(), moment()];
        settings.ranges[Txt.rangeLast7days] = [moment().subtract(6, "days"), moment()];
        settings.ranges[Txt.rangeNext7days] = [moment(), moment().add(6, "days")];
        settings.ranges[Txt.rangeLastMonth] =
            [moment().subtract(1, "month").startOf("month"), moment().subtract(1, "month").endOf("month")];
        settings.ranges[Txt.rangeCurrentMonth] = [moment().startOf("month"), moment().endOf("month")];
        settings.ranges[Txt.rangeNextMonth] = [moment().add(1, "month").startOf("month"), moment().add(1, "month").endOf("month")];
        settings.ranges[Txt.rangePreviousQuarter] = [moment().subtract(1, "quarter").startOf("quarter"), moment().subtract(1, "quarter").endOf("quarter")];
        settings.ranges[Txt.rangeCurrentQuarter] = [moment().startOf("quarter"), moment().endOf("quarter")];

        return settings;
    }

    initialize(parent: HTMLElement)
    {
        parent.append(this.inputRow[0]);
    }

    async setValue(value)
    {
        this.currentValue = value;
        if (value)
        {
            const parts = value.split("|");
            this.input.data("daterangepicker").setStartDate(parts[0]);
            this.input.data("daterangepicker").setEndDate(parts[1]);
            this.input.val(parts[0] + " - " + parts[1]);
        }
        else
        {
            this.input.val("");
        }
    }

    getValue()
    {
        return this.currentValue;
    }

    onChange(action)
    {
        this.onChangeAction = action;
    }

    focus()
    {
        this.input.focus();
    }
}
